var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57124 14.6801L3.017 8.42439C2.88645 7.89894 3.53923 7.54565 3.90296 7.94491C5.76044 9.98387 9.10844 9.28832 10.0115 6.67585L11.2582 3.06936C11.5153 2.32549 12.5536 2.30551 12.8388 3.03894L14.4255 7.11902C15.3589 9.51921 18.5081 10.0334 20.1479 8.05343C20.4752 7.65825 21.1081 7.98164 20.9841 8.48069L19.4439 14.6801C18.8882 16.9166 16.8911 18.4856 14.6 18.4856H9.4151C7.124 18.4856 5.12691 16.9166 4.57124 14.6801Z",
    strokeWidth: 1.5,
    fill: "none",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51814 19.9928C4.51814 19.1604 5.18877 18.4856 6.01603 18.4856L18.5021 18.4856C19.3294 18.4856 20 19.1604 20 19.9928C20 20.8252 19.3294 21.5 18.5021 21.5L6.01603 21.5C5.18877 21.5 4.51814 20.8252 4.51814 19.9928Z",
    strokeWidth: 1.5,
    fill: "none",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.969044cee71680adc269fef4a46209d3.svg";
export { ForwardRef as ReactComponent };